import axios from "axios";
import React, { useMemo } from "react";
import { Navigate, Route, Routes  } from "react-router-dom";
import { useGroupChatContext } from "./context/groupchatContext";
import setupAxios from "./helpers/setupAxios";
import GroupChat from "./pages/groupChat";
import Login from "./pages/login"
import ProviderLandingPage from "./pages/provider";
import ForgetPassword from "./pages/login/forgetPassword";
import ResetPassword from "./pages/login/resetPassword";

export function AppRoutes() {
    
    const groupChatContext = useGroupChatContext();

    const {authData, setAuthData} = useMemo(() => ({
        authData: groupChatContext.authData,
        setAuthData: groupChatContext.setAuthData
    }));

    setupAxios(axios, authData, setAuthData);
    return (
        <Routes>
            {!authData?.auth ? (
                <Route>
                    <Route path="auth/login" element={<Login />} />
                    <Route path="auth/forgot-password" element={<ForgetPassword />} />
                    <Route path="auth" element={<Navigate from="/auth" exact={true} to="/auth/login" />} />
                    <Route path="" element={<Navigate from="/" exact={true} to="/auth/login" />} />
                </Route>
            ) : (
                <Route>
                    <Route path="/" element={<GroupChat />} />
                    <Route path="auth/login" element={<Navigate from="/auth/login" exact={true} to="/" />} />
                </Route>
            )}
            <Route path="auth/reset-password/:token" element={<ResetPassword />} />
            <Route path="/provider" element={<ProviderLandingPage />} />
        </Routes>
    );
}
